export const countries = [
  { title: "USA", value: "USA" },
  { title: "India", value: "IND" },
  { title: "Mexico", value: "MEX" },
  { title: "Canada", value: "CAN" },
  { title: "Brazil", value: "BRA" },
  { title: "Argentina", value: "ARG" },
  { title: "Other", value: "OTHER" }, 
];

export const USA_STATE = [
  { title: "Alabama", value: "AL" },
  { title: "Alaska", value: "AK" },
  { title: "American Samoa", value: "AS" },
  { title: "Arizona", value: "AZ" },
  { title: "Arkansas", value: "AR" },
  { title: "California", value: "CA" },
  { title: "Colorado", value: "CO" },
  { title: "Connecticut", value: "CT" },
  { title: "Delaware", value: "DE" },
  { title: "District Of Columbia", value: "DC" },
  { title: "Federated States Of Micronesia", value: "FM" },
  { title: "Florida", value: "FL" },
  { title: "Georgia", value: "GA" },
  { title: "Guam Gu", value: "GU" },
  { title: "Hawaii", value: "HI" },
  { title: "Idaho", value: "ID" },
  { title: "Illinois", value: "IL" },
  { title: "Indiana", value: "IN" },
  { title: "Iowa", value: "IA" },
  { title: "Kansas", value: "KS" },
  { title: "Kentucky", value: "KY" },
  { title: "Louisiana", value: "LA" },
  { title: "Maine", value: "ME" },
  { title: "Marshall Islands", value: "MH" },
  { title: "Maryland", value: "MD" },
  { title: "Massachusetts", value: "MA" },
  { title: "Michigan", value: "MI" },
  { title: "Minnesota", value: "MN" },
  { title: "Mississippi", value: "MS" },
  { title: "Missouri", value: "MO" },
  { title: "Montana", value: "MT" },
  { title: "Nebraska", value: "NE" },
  { title: "Nevada", value: "NV" },
  { title: "New Hampshire", value: "NH" },
  { title: "New Jersey", value: "NJ" },
  { title: "New Mexico", value: "NM" },
  { title: "New York", value: "NY" },
  { title: "North Carolina", value: "NC" },
  { title: "North Dakota", value: "ND" },
  { title: "Northern Mariana Islands", value: "MP" },
  { title: "Ohio", value: "OH" },
  { title: "Oklahoma", value: "OK" },
  { title: "Oregon", value: "OR" },
  { title: "Palau", value: "PW" },
  { title: "Pennsylvania", value: "PA" },
  { title: "Puerto Rico", value: "PR" },
  { title: "Rhode Island", value: "RI" },
  { title: "South Carolina", value: "SC" },
  { title: "South Dakota", value: "SD" },
  { title: "Tennessee", value: "TN" },
  { title: "Texas", value: "TX" },
  { title: "Utah", value: "UT" },
  { title: "Vermont", value: "VT" },
  { title: "Virgin Islands", value: "VI" },
  { title: "Virginia", value: "VA" },
  { title: "Washington", value: "WA" },
  { title: "West Virginia", value: "WV" },
  { title: "Wisconsin", value: "WI" },
  { title: "Wyoming", value: "WY" },
];

export const INDIA_STATE = [
  { value: "AN", title: "Andaman and Nicobar Islands" },
  { value: "AP", title: "Andhra Pradesh" },
  { value: "AR", title: "Arunachal Pradesh" },
  { value: "AS", title: "Assam" },
  { value: "BR", title: "Bihar" },
  { value: "CG", title: "Chandigarh" },
  { value: "CH", title: "Chhattisgarh" },
  { value: "DH", title: "Dadra and Nagar Haveli" },
  { value: "DD", title: "Daman and Diu" },
  { value: "DL", title: "Delhi" },
  { value: "GA", title: "Goa" },
  { value: "GJ", title: "Gujarat" },
  { value: "HR", title: "Haryana" },
  { value: "HP", title: "Himachal Pradesh" },
  { value: "JK", title: "Jammu and Kashmir" },
  { value: "JH", title: "Jharkhand" },
  { value: "KA", title: "Karnataka" },
  { value: "KL", title: "Kerala" },
  { value: "LD", title: "Lakshadweep" },
  { value: "MP", title: "Madhya Pradesh" },
  { value: "MH", title: "Maharashtra" },
  { value: "MN", title: "Manipur" },
  { value: "ML", title: "Meghalaya" },
  { value: "MZ", title: "Mizoram" },
  { value: "NL", title: "Nagaland" },
  { value: "OR", title: "Odisha" },
  { value: "PY", title: "Puducherry" },
  { value: "PB", title: "Punjab" },
  { value: "RJ", title: "Rajasthan" },
  { value: "SK", title: "Sikkim" },
  { value: "TN", title: "Tamil Nadu" },
  { value: "TS", title: "Telangana" },
  { value: "TR", title: "Tripura" },
  { value: "UK", title: "Uttar Pradesh" },
  { value: "UP", title: "Uttarakhand" },
  { value: "WB", title: "West Bengal" },
];

export const MEXICO_STATE = [
  { value: "AG", title: "Aguascalientes" },
  { value: "BC", title: "Baja California" },
  { value: "BS", title: "Baja California Sur" },
  { value: "CH", title: "Chihuahua" },
  { value: "CL", title: "Colima" },
  { value: "CM", title: "Campeche" },
  { value: "CO", title: "Coahuila" },
  { value: "CS", title: "Chiapas" },
  { value: "DF", title: "Ciudad de México" },
  { value: "DG", title: "Durango" },
  { value: "GR", title: "Guerrero" },
  { value: "GT", title: "Guanajuato" },
  { value: "HG", title: "Hidalgo" },
  { value: "JA", title: "Jalisco" },
  { value: "ME", title: "Estado de México" },
  { value: "MI", title: "Michoacán" },
  { value: "MO", title: "Morelos" },
  { value: "NA", title: "Nayarit" },
  { value: "NL", title: "Nuevo León" },
  { value: "OA", title: "Oaxaca" },
  { value: "PU", title: "Puebla" },
  { value: "QE", title: "Querétaro" },
  { value: "QR", title: "Quintana Roo" },
  { value: "SL", title: "San Luis Potosí" },
  { value: "SI", title: "Sinaloa" },
  { value: "SO", title: "Sonora" },
  { value: "TB", title: "Tabasco" },
  { value: "TL", title: "Tlaxcala" },
  { value: "TM", title: "Tamaulipas" },
  { value: "VE", title: "Veracruz" },
  { value: "YU", title: "Yucatán" },
  { value: "ZA", title: "Zacatecas" },
];

export const CANADA_STATE = [
  { value: "AB", title: "Alberta" },
  { value: "BC", title: "British Columbia" },
  { value: "MB", title: "Manitoba" },
  { value: "NB", title: "New Brunswick" },
  { value: "NL", title: "Newfoundland and Labrador" },
  { value: "NS", title: "Nova Scotia" },
  { value: "NT", title: "Northwest Territories" },
  { value: "NU", title: "Nunavut" },
  { value: "ON", title: "Ontario" },
  { value: "PE", title: "Prince Edward Island" },
  { value: "QC", title: "Quebec" },
  { value: "SK", title: "Saskatchewan" },
  { value: "YT", title: "Yukon" },
];

export const BRAZIL_STATE = [
  { value: "AC", title: "Acre" },
  { value: "AL", title: "Alagoas" },
  { value: "AP", title: "Amapá" },
  { value: "AM", title: "Amazonas" },
  { value: "BA", title: "Bahia" },
  { value: "CE", title: "Ceará" },
  { value: "DF", title: "Distrito Federal" },
  { value: "ES", title: "Espírito Santo" },
  { value: "GO", title: "Goiás" },
  { value: "MA", title: "Maranhão" },
  { value: "MT", title: "Mato Grosso" },
  { value: "MS", title: "Mato Grosso do Sul" },
  { value: "MG", title: "Minas Gerais" },
  { value: "PA", title: "Pará" },
  { value: "PB", title: "Paraíba" },
  { value: "PR", title: "Paraná" },
  { value: "PE", title: "Pernambuco" },
  { value: "PI", title: "Piauí" },
  { value: "RJ", title: "Rio de Janeiro" },
  { value: "RN", title: "Rio Grande do Norte" },
  { value: "RS", title: "Rio Grande do Sul" },
  { value: "RO", title: "Rondônia" },
  { value: "RR", title: "Roraima" },
  { value: "SC", title: "Santa Catarina" },
  { value: "SP", title: "São Paulo" },
  { value: "SE", title: "Sergipe" },
  { value: "TO", title: "Tocantins" },
];

export const ARGENTINA_STATE = [
  { value: "BA", title: "Buenos Aires" },
  { value: "CABA", title: "Ciudad Autónoma de Buenos Aires" },
  { value: "CAT", title: "Catamarca" },
  { value: "CHA", title: "Chaco" },
  { value: "CHU", title: "Chubut" },
  { value: "COR", title: "Córdoba" },
  { value: "ERI", title: "Entre Ríos" },
  { value: "FOR", title: "Formosa" },
  { value: "JUJ", title: "Jujuy" },
  { value: "LAP", title: "La Pampa" },
  { value: "LAR", title: "La Rioja" },
  { value: "MEN", title: "Mendoza" },
  { value: "MIS", title: "Misiones" },
  { value: "NEU", title: "Neuquén" },
  { value: "RIO", title: "Río Negro" },
  { value: "SAL", title: "Salta" },
  { value: "SAM", title: "San Luis" },
  { value: "SJU", title: "San Juan" },
  { value: "SFE", title: "Santa Fe" },
  { value: "SFO", title: "Santiago del Estero" },
  { value: "TDF", title: "Tierra del Fuego" },
  { value: "TUC", title: "Tucumán" },
];

export const getStateList = (country) => {
  switch (country) {
    case "IND":
      return INDIA_STATE;
    case "USA":
      return USA_STATE;
    case "MEX":
      return MEXICO_STATE;
    case "CAN":
      return CANADA_STATE;
    case "BRA":
      return BRAZIL_STATE;
    case "ARG":
      return ARGENTINA_STATE;
    case "OTHER":
      return [];
    default:
      return [];
  }
};
